<template>
  <div class="fts-text-area">
    <textarea
      class="fts-form-control"
      :class="{'form-control--error': error}"
      v-model="model"
      autocomplete="ftsTextArea"
      :rows="rows"
      ref="textArea"
      @input="event => $emit('input', event)"
      @blur="event => $emit('blur', event)"
    ></textarea>
  </div>
</template>

<script>
export default {
  props: {
    rows: {
      type: Number,
      default: 4
    },
    error: Boolean,
    value: String,
    formData: Object,
    item: Object
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  data: () => ({
    resizeObserver: null
  }),
  methods: {
    autosizeTextarea(el) {
      el.style.height = "auto";
      const elHeight = (el.scrollHeight + 2) + "px";
      el.style.height = elHeight;
      this.$el.style.minHeight = elHeight;
      this.$emit('updateHeight', elHeight);
    },
    focus() {
      this.$refs["textArea"].focus();
    }
  },
  computed: {
    model: {
      get() {
        if (this.item && this.item.fieldName) {
          return this.formData[this.item.fieldName];
        } else {
          return this.value;
        }
      },
      set(val) {
        if (this.item && this.item.fieldName) {
          this.$set(this.formData, this.item.fieldName, val);
        } else {
          this.$emit("updateValue", val);
        }
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler(val, oldVal) {
        if (val !== oldVal && oldVal !== undefined) {
          this.$nextTick(() => {
            this.autosizeTextarea(this.$refs.textArea);
          });
        }
      },
    },
  },
  async mounted() {
    await this.$nextTick();
    let prevWidth = 0;
    this.resizeObserver = new ResizeObserver(_.debounce((entries) => {
      try {
        const entry = entries.find(x => x.target === this.$refs.textArea);
        if (entry) {
          const currWidth = entry.target.scrollWidth;
          if (prevWidth !== currWidth) {
            this.autosizeTextarea(entry.target);
          }
          prevWidth = currWidth;
        }
      } catch(err) {
        console.warn("[DOMException]:ResizeObserver", err);
      }
    }, 500));

    if (this.model !== null && this.model !== undefined)
      this.model = this.model.trimEnd();
    this.autosizeTextarea(this.$refs.textArea);
    this.resizeObserver.observe(this.$refs.textArea);
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.$refs.textArea);
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }
};
</script>

<style lang="scss" scoped>
textarea {
  resize: none;
  overflow: hidden;
  transition: none !important;
}
</style>